export default "__VITE_ASSET__6a8ad5a0__"